import {Component, Input} from '@angular/core';
import {MainLightboxService} from '../../../layout/main-lightbox.service';

export interface ProfileStatusAvatarModel {
  avatar: string;
  status_class: string;
  status_extended_registration_class: string;
}

@Component({
  selector: 'app-profile-status-avatar',
  templateUrl: './profile-status-avatar.component.html',
  styleUrls: ['./profile-status-avatar.component.scss']
})
export class ProfileStatusAvatarComponent {
  @Input() model: ProfileStatusAvatarModel;

  constructor(
    protected mainLightboxService: MainLightboxService,
  ) {
  }

  getAvatarSrc(avatar: string): string {
    return avatar ? 'data:image/jpeg;base64,' + avatar : 'assets/img/no-user-avatar.svg';
  }

  clickableImage(url: string) {
    return url && !url.startsWith('assets');
  }

  onImageClick(imageData: string) {
    if (this.clickableImage(imageData)) {
      const srcImage = {
        src: imageData,
        id: 0,
      };
      const onImageClientClick = [srcImage];
      this.mainLightboxService.open(onImageClientClick);
    }
  }
}
